module.exports = __webpack_public_path__ + "345e6774.webp";